<template>
  <div class="sidebar-logo-container f-l">
    <transition name="sidebarLogoFade">
      <router-link  class="sidebar-logo-link" to="/">
        <img :src="logo" class="sidebar-logo">
        河马IPMS
      </router-link>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo',
  data() {
    return {
      title: 'Vue Admin Template',
      logo: 'static/images/logo.png'
    }
  }
}
</script>

<style lang="scss" scoped>
.f-l{
    float: left;
}
.sidebar-logo-container {
    width: 271px;
    text-align: center;
    position: absolute;
    left: 0;
    z-index: 1000;
}
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  text-align: center;
  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    text-decoration: none;
    font-weight: bold;
    & .sidebar-logo {
      width: 32px;
      height: 32px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
